// State
const state = {
  args: {
    custom_per_page: 10,
    page: 1
  },
  search: '',
  filters: [],
  filter: null,
  posts: [],
  isLoading: false
};

// Getters
const getters = {
  search: (state) => state.search,
  filters: (state) => state.filters,
  isLoading: (state) => state.isLoading,
  posts: (state) => {
    let posts = state.posts;

    if (state.filter) {
      posts = posts.filter((item) => {
        return item.recipe_categories.includes(state.filter);
      });
    }

    if (state.search) {
      posts = posts.filter((item) => {
        return (
          item.title.rendered
            .toLowerCase()
            .indexOf(state.search.toLowerCase()) > -1
        );
      });
    }

    return posts;
  }
};

// Actions
const actions = {
  async getPosts({ commit, state, dispatch }) {
    commit('setLoading', true);

    fetch(
      tofinoJS.siteURL +
        '/wp-json/wp/v2/recipe?' +
        new URLSearchParams(state.args)
    )
      .then(async (response) => {
        let posts = await response.json();

        const existingPosts = state.posts;
        const totalPages = response.headers.get('X-WP-TotalPages');
        const currentPage = state.args.page;

        existingPosts.push(...posts);

        commit('setPosts', existingPosts);

        if (currentPage < totalPages) {
          commit('setArgs', {
            page: currentPage + 1
          });
          dispatch('getPosts');
        }

        commit('setLoading', false);

        return true;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  getRecipeCategories({ commit }) {
    fetch(tofinoJS.siteURL + '/wp-json/wp/v2/recipe_categories')
      .then(async (response) => {
        const categories = await response.json();

        commit('setFilters', categories);
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

// Mutations
const mutations = {
  setPosts(state, data) {
    state.posts = data;
  },
  setFilters(state, data) {
    state.filters = data;
  },
  setSearch(state, data) {
    state.search = data;
  },
  setFilter(state, data) {
    state.filter = data;
  },
  setCategory(state, catId) {
    state.args.recipe_categories = catId;
  },
  setLabel(state, termId) {
    state.args.recipe_labels = termId;
  },
  setTag(state, termId) {
    state.args.recipe_tags = termId;
  },
  setLoading(state, data) {
    state.isLoading = data;
  },
  setArgs(state, data) {
    state.args = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
